import React from "react";
import { connect } from "react-redux";
import { array, object, number, bool, string } from "prop-types";
import get from "lodash/get";

import CustomStoryCard3 from "../custom-story-card3";
import { wruUserEvent } from "../../helper/api";
import { readCookie } from "../../helper/cookies";
import translate from "../../translate";

import "./wru-also-read.m.css";

const Card = ({ item }) => {
  const story = {
    headline: item.Description,
    url: `/${item.Slug}`,
    "hero-image-s3-key": item.ImageUrl,
    "hero-image-metadata": item.ImageMetaData,
  };

  return (
    <CustomStoryCard3
      story={story}
      aspectRatio={[16, 9]}
      defaultWidth={36}
      imageType="image16x9"
      showStoryTypeIcon={false}
      headerType={3}
      useAlternateHeadline
      id="ga-wru-also-read"
    />
  );
};

Card.propTypes = {
  item: object,
};

const WruAlsoRead = ({ items, hideInMobile, index, merchantId, publisherName }) => {
  if (!items.length || (index !== 0 && global.width < 768 && hideInMobile)) return null;

  const handleUserClick = (item) => () => {
    const body = {
      uid: readCookie("thinmint"),
      Cid: item.Cid, // article id
      eid: "EVENT1",
      merchantId: `${merchantId}`,
      ip: "",
      timestamp: `${new Date().getTime()}`,
      eventType: "RECOMMENDATION_VIEW_EVENT",
      recommendation: "wru",
      ref: "Also Read Right", // the heading of the recommendation widget
      userAgent:
        "Mozilla/5.0 (iPhone; CPU iPhone OS 11_0 like Mac OS X) AppleWebKit/604.1.38 (KHTML, like Gecko) Version/11.0 Mobile/15A372 Safari/604.1",
    };

    wruUserEvent(merchantId, body).then((i) => console.log("Wru click event", i));
  };

  return (
    <div styleName="wrapper">
      <div styleName="title">{translate(publisherName, "more_news")}</div>
      <div styleName="items">
        {items.map((item, index) => (
          <div key={index} onClick={handleUserClick(item)}>
            <Card item={item} key={index} />
          </div>
        ))}
      </div>
    </div>
  );
};

WruAlsoRead.propTypes = {
  items: array,
  index: number,
  merchantId: number,
  hideInMobile: bool,
  publisherName: string,
};

const mapStateToProps = (state) => {
  const WruItems = get(state, ["storyReducer", "wruData"], []);
  const hideInMobile = get(state, ["qt", "config", "publisher-attributes", "hide_in_mobile", "also_read"], false);
  const items = WruItems.find((i) => i.category === "also_read_right");

  return {
    items: (items && items.recommendations) || [],
    merchantId: get(state, ["qt", "config", "publisher-attributes", "wru_id"]),
    publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
    hideInMobile,
  };
};

export default connect(mapStateToProps, null)(WruAlsoRead);
